import {
  COMPLETE_SUBSCRIPTION_REQUEST,
  COMPLETE_SUBSCRIPTION_SUCCESS,
  COMPLETE_SUBSCRIPTION_ERROR,
} from "./actions";

const initialState = {
  requesting: false,
  successful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case COMPLETE_SUBSCRIPTION_REQUEST:
      return {
        requesting: true,
        successful: false,
      };

    case COMPLETE_SUBSCRIPTION_SUCCESS:
      return {
        requesting: false,
        successful: true,
      };

    case COMPLETE_SUBSCRIPTION_ERROR:
      return {
        requesting: false,
        successful: false,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/complete-subscription/reducer.js